import React from 'react'
import Center from './Center'
import { StyleSheet, css } from 'aphrodite';
import bg from '../../static/bg-cta.jpg'
import { Typography } from 'antd';

let styles = StyleSheet.create({
    background: {
        backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),url(${bg})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        textAlign: 'center',
        color: '#fff',
        padding: '8% 0 8% 0%',
    },
    h2: {
        fontSize: '2em',
        color: '#fff',

    },
    btn: {
        border: `1px solid`,
        padding: `15px 20px`,
        // fontSize: 'min(1vw,36px)',
        borderRadius: '300px',
        color: '#fff',
        letterSpacing: '2px',
        backgroundColor: 'transparent'

    }
})
const Intro4 = () => {
    return (
        <div className={css(styles.background)}>
            <div style={{
                color: '#fff',

            }}>
                <Center >
                    <Typography.Title style={{ color: '#fff' }}>
                        Stop waiting. <br />
                        Start playing now.
                    </Typography.Title>
                    <h2 className={css(styles.h2)}>
                    </h2>
                    <a href="https://itunes.apple.com/kw/app/meetain/id1089582421?mt=8">
                        <Typography.Title level={4} className={css(styles.btn)}>
                            Let's Get Started!
                        </Typography.Title>
                    </a>
                </Center>
            </div>

        </div>

    )
}

export default Intro4
